export default __webpack_public_path__ + "static/media/Illustration.8deb16f7.png";